'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'book-bookmark';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e0bb';
var svgPathData = 'M0 0l448 0 0 416-32 0 0 64 32 0 0 32-448 0 0-64 0 0 0-432 0-16zM320 32l-96 0 0 135.5c23.5-14.1 39.5-23.7 48-28.8 8.5 5.1 24.5 14.7 48 28.8L320 32zM192 32L32 32 32 392.6c9.4-5.4 20.3-8.6 32-8.6l352 0 0-352-64 0 0 192c-18.7-11.2-45.3-27.2-80-48-34.7 20.8-61.3 36.8-80 48l0-192zM64 416c-17.7 0-32 14.3-32 32l0 32 352 0 0-64-320 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBookBookmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;